<template>
  <v-footer class="bg-red-700 max-h-14 mt-auto" style="z-index: 1004">
    <div class="flex justify-between items-center w-full p-2">
      <h6 class="font-medium text-sm text-white font-inter">
        Provided by Digitech - GEMS. &copy; {{ new Date().getFullYear() }} PT.
        Borneo Indobara
      </h6>
      <span class="text-white text-sm font-inter">v.20261102.3</span>
    </div>
  </v-footer>
</template>

<script>
export default {
  name: "FooterLayout",
};
</script>
<style scoped>
@import url("./../assets/css/tailwind.css");
</style>
